/** Indian mobile: starts with 6–9, exactly 10 digits. */
export const INDIAN_MOBILE_REGEX = /^[6-9]\d{9}$/;

export function isValidIndianMobile(number) {
  return INDIAN_MOBILE_REGEX.test(String(number || "").replace(/\D/g, ""));
}

export function formatIndianPhoneNumber(number) {
  const digits = String(number || "")
    .replace(/\D/g, "")
    .slice(-10);

  if (!digits) return "+91";
  if (digits.length < 10) return `+91 ${digits}`;
  return `+91 ${digits.slice(0, 5)} ${digits.slice(5)}`;
}
